import { axiosClient } from "@/shared/api/axios-client";

/** Hotspot 55 · conteos de eventos con error de un módulo (outbox). */
export interface ResumenOutboxModulo {
  modulo: string;
  agotados: number;
  enReintento: number;
}

/** Evento de integración del outbox que falló al despacharse. */
export interface EventoFallido {
  id: string;
  modulo: string;
  eventType: string;
  eventoNombre: string;
  occurredAt: string;
  retryCount: number;
  maxRetries: number;
  nextAttemptAt: string | null;
  /** `Agotado` (sin más intentos automáticos) | `Reintentando`. */
  estado: "Agotado" | "Reintentando";
  error: string | null;
  payload: string;
}

export interface PaginaEventosFallidos {
  items: EventoFallido[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ListarEventosFallidosParams {
  modulo: string;
  soloAgotados?: boolean;
  page?: number;
  pageSize?: number;
}

const BASE = "/api/admin/eventos-fallidos";

export async function resumirEventosFallidos(): Promise<ResumenOutboxModulo[]> {
  const { data } = await axiosClient.get<ResumenOutboxModulo[]>(`${BASE}/modulos`);
  return data;
}

export async function listarEventosFallidos(params: ListarEventosFallidosParams): Promise<PaginaEventosFallidos> {
  const { data } = await axiosClient.get<PaginaEventosFallidos>(BASE, { params });
  return data;
}

export async function reprocesarEventoFallido(modulo: string, id: string): Promise<void> {
  await axiosClient.post(`${BASE}/${encodeURIComponent(modulo)}/${id}/reprocesar`);
}
